<template>
    <v-app id="inspire">

        <z-menu v-model="drawer"></z-menu>

        <v-app-bar
                :clipped-left="$vuetify.breakpoint.lgAndUp"
                app
                color="#2E2E2E"
                dark>

            <v-app-bar-nav-icon style="font-size:3rem;" @click.stop="drawer = !drawer"/>

            <v-toolbar-title
                    class="ml-0 pl-4 flex-view-style"
            >
                <div style="width:35px;margin-right: 1rem;">
                    <v-img src="https://zzitec-hosp-prd.oss-cn-shanghai.aliyuncs.com/public/daqweb/logo%402x.png?OSSAccessKeyId=LTAI5tBvPHnS8BRZfCWrRwvj&Expires=1001753346683&Signature=qxyqvhGNyp5RdIm5eKkkUBTYLmw%3D"></v-img>
                </div>
                <span class="hidden-sm-and-down">棕旨</span>
            </v-toolbar-title>
            <v-spacer/>
            <div>{{this.currentTitle}}</div>
            <v-spacer/>
            <div class="mr-6">
                <span>{{this.acctName}}</span>，
                <span>{{nowTime}}</span>
            </div>
        </v-app-bar>

        <v-content style="background-color:#F7F7F7">
            <transition name="fade-transform" mode="out-in">
                <!--<keep-alive>-->
                    <router-view/>
                <!--</keep-alive>-->
            </transition>
        </v-content>

    </v-app>
</template>

<script>
  import ZMenu from "@/components/ZMenu"
  import {mapGetters} from "vuex"
  import {getTime} from "@/utils/getTime"
  import scrypt from '@/utils/scrypt'
  import ZSetUp from "@/components/ZSetUp"

  export default {
    props: {
      source: String,
    },
    components: {
      ZMenu,
      ZSetUp
    },
    computed: {
      ...mapGetters([
        'currentTitle',
        'acctName',
        'routers'
      ]),
    },
    watch:{
      $route(to,from){
        for(var i=0;i<this.routers.length;i++){
          if(to.path==this.routers[i].path){
            this.$store.dispatch('setCurretTitle',this.routers[i].meta.title);
          }
        }
      }
    },
    data: () => ({
      dialog: false,
      drawer: false,
      nowTime: ''
    }),
    methods: {

    },
    created() {
      this.nowTime = getTime();
    }
  }
</script>
